import { parseSeparatorDelimitedTime } from './parse'
import isSameDate from './isSameDate'
import humanReadableDateDiff from './humanReadableDateDiff'

export { parseSeparatorDelimitedTime, isSameDate, humanReadableDateDiff }

export interface IDateRange {
  from: Date | null
  to: Date | null
}
